// テキスト分析のネガポジ色を CSS 変数から解決する小さなヘルパー。
// canvas(ワードクラウド)と vis-network は CSS 変数を直接扱えないため、描画のたびに実色へ解決する。
// 変数の定義は app/assets/stylesheets/application.tailwind.css(:root と [data-theme="dark"])。
const CSS_VARIABLES = {
  positive: '--tm-sentiment-positive',
  negative: '--tm-sentiment-negative',
  neutral: '--tm-sentiment-neutral'
}

// CSS 変数名を指定して実色を取る。テーマ切替後も拾えるよう、呼び出しのたびに解決する(キャッシュしない)
export function cssColor(variable) {
  if (!variable) return null

  const color = getComputedStyle(document.documentElement).getPropertyValue(variable).trim()
  return color || null
}

export function sentimentColor(sentimentClass) {
  return cssColor(CSS_VARIABLES[sentimentClass])
}

// { 語 => "positive" } を { 語 => "#1D4ED8" } に解決する
export function resolveSentimentColors(sentimentClasses) {
  if (!sentimentClasses) return null

  const resolved = {}
  Object.keys(sentimentClasses).forEach((word) => {
    const color = sentimentColor(sentimentClasses[word])
    if (color) resolved[word] = color
  })
  return resolved
}
